export default "__VITE_ASSET__e8048b49__"